var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('context-menu-simple'),_c('context-menu-close-on-click')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }